import { ReactNode } from "react";
import styled from "styled-components";

import { MEDIA_MOBILE_BREAKPOINT } from "src/apps/config/constants";
import { Text, TextBold } from "src/apps/components/typography/Texts";
import { colors } from "@permisso/permisso-components";

interface OpenAdminAtomicBannerProps {
  title: string;
  description?: string;
  leftComponent?: ReactNode;
  rightComponent?: ReactNode;
  borderColor?: string;
  leftAlign?: "center" | "flex-start";
}

/**
 * This shitty name is to differentiate what should go to
 * the permisso components library. Should be changed
 *  */
export const OpenAdminAtomicBanner = ({
  title,
  description,
  leftComponent,
  rightComponent,
  borderColor = colors.grey400,
  leftAlign = "center",
}: OpenAdminAtomicBannerProps) => {
  return (
    <Container $borderColor={borderColor} $leftAlign={leftAlign}>
      <Row>
        {leftComponent ? <LeftContainer>{leftComponent}</LeftContainer> : null}
        <Centered>
          <ContentContainer>
            <TitleText $color={colors.grey700}>{title}</TitleText>
            {description ? (
              <DescriptionText $color={colors.grey700}>{description}</DescriptionText>
            ) : null}
          </ContentContainer>
        </Centered>
      </Row>
      {rightComponent ? <RightContainer>{rightComponent}</RightContainer> : null}
    </Container>
  );
};

const Row = styled.div`
  display: flex;
  gap: 1rem;
  flex: 1;
  flex-direction: row;
  @media (max-width: ${MEDIA_MOBILE_BREAKPOINT}rem) {
    flex-direction: row;
  }
`;

const Centered = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  gap: 2rem;
`;

const Container = styled.div<{ $borderColor: string; $leftAlign: "center" | "flex-start" }>`
  display: flex;
  justify-content: space-between;
  align-items: ${({ $leftAlign }) => $leftAlign ?? "center"};
  gap: 1rem;
  padding: 1.5rem;
  border-radius: 0.5rem;
  border: 0.09375rem solid ${({ $borderColor }) => $borderColor} !important;
  background-color: ${colors.grey200};
  @media (max-width: ${MEDIA_MOBILE_BREAKPOINT}rem) {
    flex-direction: column;
    align-items: flex-start;
    gap: 1rem;
    min-height: unset;
    padding: 0.75rem;
  }
`;

const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 0.25rem;
`;

const LeftContainer = styled.div`
  display: flex;
  align-items: flex-start;
`;

const RightContainer = styled.div`
  display: flex;
  align-self: center;
  align-items: center;
  justify-content: flex-end;
  width: 13.5rem;
  @media (max-width: ${MEDIA_MOBILE_BREAKPOINT}rem) {
    width: 100%;
  }
`;

const TitleText = styled(TextBold)`
  line-height: 1.5rem;
`;

const DescriptionText = styled(Text)`
  line-height: 1.35rem;
  font-size: 0.875rem;
`;
